module.exports = __webpack_public_path__ + "static/img/wl1150.ec9e86c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wl1150.jpg
// module id = mOha
// module chunks = 0